"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var useAuth_1 = require("../../useAuth");
var styledComponents_1 = require("../styledComponents");
var Logout = function () {
    var ref = (0, react_1.useRef)();
    var _a = (0, useAuth_1.useAuth)(), PingSLO = _a.PingSLO, logout = _a.logout;
    (0, react_1.useEffect)(function () {
        ref.current.onload = function () { return logout(); };
    }, [logout]);
    return (react_1.default.createElement(styledComponents_1.StyledContainer, null,
        react_1.default.createElement(styledComponents_1.StyledText, null, "Logging out..."),
        react_1.default.createElement(styledComponents_1.StyledLoader, null),
        react_1.default.createElement(StyledIFrame, { title: "Ping-IDP-Logout", ref: ref, src: PingSLO, width: "0", height: "0" })));
};
exports.default = Logout;
var StyledIFrame = styled_components_1.default.iframe(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: none;\n  border: none;\n"], ["\n  display: none;\n  border: none;\n"])));
var templateObject_1;
